import { createFileRoute } from "@tanstack/react-router";
import { AgendaShell } from "@/components/agenda/agenda-shell";
import { AgendaChamados } from "@/components/agenda/agenda-chamados";

export const Route = createFileRoute("/agenda/chamados")({
  component: () => (
    <AgendaShell>
      <AgendaChamados />
    </AgendaShell>
  ),
  head: () => ({ meta: [{ title: "Chamados — Agenda — GPS Drive" }] }),
});
